export default "__VITE_ASSET__9a876ad2__"